<template>
  <div>

    <div>
      <app-button :disabled="disabledGenerateDecision" @click="generateDocument" :loading="this.activeDocumentSetup && this.activeDocumentSetup.id ? createLoading : false"
                  :c_permission="C_GENERATE_DECISION" class=" ml-3 pull-right">
        {{ $t('GENERATE_DECISION') }}
      </app-button>
      <app-button v-if="0" :loading="pdf_loader" :disabled="disabledGenerateDecision" @click="fetchPdfDecision"
                  :c_permission="C_GENERATE_DECISION" class=" ml-3 pull-right">
        {{ $t('GENERATE_DECISION') }} old
      </app-button>
    </div>
    <table class="w-table" v-if="activeDocumentSetup && activeDocumentSetup.id">
      <tr>
        <td>
          <div class="w-table-header  -accordion border-bottom">
            <h3 class="w-table-header__heading">
              {{$t('DECISION_DOCUMENT')}} <span class="record-created">{{$t('RECORD_WAS_CREATED')}}:  {{activeDocumentSetup.user_insert}}, {{formatDate(activeDocumentSetup.created_at)}} </span> <span class="badge ml-1 badge-success">Active</span>
            </h3>
            <collapse :opened="visibility['activeDecision']" @opened="opened('activeDecision')"  @closed="closed('activeDecision')"/>
          </div>
        </td>
      </tr>
      <tr  v-show="visibility['activeDecision']"  style="margin-top: 1rem"><td>
        <div class="accordion-content" >
          <form @submit.prevent="save">
            <b-row class="mb-2">
              <b-col  offset="6" md="6" lg="6">
                <submit-button :disabled="disabledGenerateDecision" class="pull-right" :loading="loading"></submit-button>
              </b-col>
            </b-row>
            <quill-editor ref="richEditor" :value="activeDocumentSetup.data" @input="updateData"></quill-editor>

          </form>
        </div>
      </td>
      </tr>
      <template v-for="(documentSetup, index) in documentSetupList">
        <tr :key="index">
          <td>
            <div class="w-table-header  -accordion border-bottom">
              <h3 class="w-table-header__heading">
                {{$t('DECISION_DOCUMENT')}}  <span class="record-created">{{$t('RECORD_WAS_CREATED')}}:  {{documentSetup.user_insert}}, {{formatDate(documentSetup.created_at)}}</span>
              </h3>
              <collapse :opened="visibility[`documentDecision_${documentSetup.id}`]" @opened="opened(`documentDecision_${documentSetup.id}`)"  @closed="closed(`documentDecision_${documentSetup.id}`)"/>
            </div>
          </td>
        </tr>
        <tr :key="`data_${index}`"  v-show="visibility[`documentDecision_${documentSetup.id}`]"  style="margin-top: 1rem"><td>
          <div class="accordion-content" >
            <quill-editor :options="{modules: {toolbar: false}}" :value="documentSetup.data" :disabled="true"></quill-editor>
          </div>
        </td>
        </tr>
      </template>
    </table>

    <app-confirmation-dialog :loading="createLoading" :title="$t('GENERATE_DECISION_TITLE')" :show="showGenerateDocumentDialog"  @cancel="showGenerateDocumentDialog=false" @confirm="createDecisionDocument">
      <template v-slot:content>
        <b>{{$t('GENERATE_DECISION_BODY')}}</b>
      </template>
    </app-confirmation-dialog>
  </div>

</template>

<script>

import {
  createRecognitionDecisionDocument,
  downloadPdfRecognitionDecision,
  getRecognitionDecisionDocumentList,
  updateRecognitionDecision
} from "@/services/recognition";
import { pdfExporter } from 'quill-to-pdf';
import {quillEditor} from 'vue-quill-editor'
import moment from "moment";
import Collapse from "@/components/app/Collapse";
import SubmitButton from '@/components/app/AppSubmit'
import {toast} from "@/shared/plugins/toastr";
import AppButton from "@/components/app/AppButton";
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import {generatePdfDecision} from "@/services/applicant";
import {STATUS_COMPLETE, STATUS_IN_PROCESS} from "@/shared/constants";
import {C_GENERATE_DECISION} from '@/shared/component_permission'
import AppConfirmationDialog from "@/components/app/form/AppConfirmationDialog";
export default {
  name: "DecisionDocument",
  data() {
    return {
      visibility: {
        activeDecision: true,
      },
      lastVersionHidden: false,
      isLastVersionVisible: false,
      loading: false,
      applicant_id: null,
      showSection:{
        activeDocumentDecision: true
      },
      C_GENERATE_DECISION,
      pdf_loader:false,
      createLoading: false,
      showGenerateDocumentDialog: false,
    };
  },
  components: {
    AppConfirmationDialog,
    AppButton,
    SubmitButton,
    quillEditor,
    Collapse,
  },
  computed: {
    globalOptions() {
      return {
        modules: {
          toolbar: 'minimal'
        },
        readOnly: true,
        theme: 'snow'
      };
    },
    ...mapGetters('applicant', ['documentSetupList', 'activeDocumentSetup']),
    applicant(){
      return this.$store.getters['applicant/getApplicant']
    },
    recognition() {
      return this.$store.getters['recognition/getRecognition'];
    },
    disabledGenerateDecision(){
      return this.applicant.status && this.applicant.status.id === STATUS_IN_PROCESS && this.recognition.id ? false : true
    }
  },
  methods:{
    generateDocument() {
      if(this.activeDocumentSetup && this.activeDocumentSetup.id) {
        this.showGenerateDocumentDialog=true;
      } else {
        this.createDecisionDocument();
      }
    },
    createDecisionDocument(){
      this.createLoading = true;
      createRecognitionDecisionDocument(this.$route.params.id) .then(response => {
        toast({
          'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
          'message': null,
          'type': 'success',
          'timeout': 2000
        })
        this.$store.dispatch('applicant/actionGetDocumentSetup', this.$route.params.id);
      }, error => {
        toast({
          'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
          'message': null,
          'type': 'error',
          'timeout': 2000
        })
      }).finally(()=>{
        this.createLoading = false
        this.showGenerateDocumentDialog = false;
      })
    },
    updateData(value) {
      this.$store.dispatch('applicant/actionSetHTMLData', value);
    },
    formatDate(value){
      if(value){
        const momentDate = new moment(value)

        return momentDate.format('DD.MM.YYYY HH:mm')
      } else {
        return null
      }
    },
    opened(name) {
      for(const[propertyName] of Object.entries(this.visibility)) {
        this.$set(this.visibility, propertyName, false)
      }
      this.$set(this.visibility, name, true);
    },
    closed(name) {
      this.$set(this.visibility, name, false);
    },
    save(){
      this.loading=true
      updateRecognitionDecision(this.$route.params.id, this.activeDocumentSetup.id, {data: this.activeDocumentSetup.data })
        .then(response => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'message': null,
            'type': 'success',
            'timeout': 2000
          })
          this.$store.dispatch('applicant/actionGetDocumentSetup', this.$route.params.id);
        }, error => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
            'message': null,
            'type': 'error',
            'timeout': 2000
          })
        }).finally(()=>{
        this.loading = false
      })
    },
    async downloadPdf(){
      console.log(this.$refs.richEditor.quill.getContents())
      const delta = this.$refs.richEditor.quill.getContents(); // gets the Quill delta
      const pdfAsBlob = await pdfExporter.generatePdf(delta); // converts to PDF
      console.log(pdfAsBlob, 4234)
      saveAs(pdfAsBlob, 'pdf-export.pdf'); // downloads from the browser*/
    },
    fetchPdfDecision(){
      this.pdf_loader = true
      generatePdfDecision(this.$route.params.id).then(response => {
        this.$store.dispatch('applicant/actionGetDocumentSetup', this.$route.params.id);
      }).finally(()=>{
        this.pdf_loader = false
      })
    }
  },

  watch: {
    '$route.params.id': {
      async handler(value) {
        this.$store.dispatch('applicant/actionGetDocumentSetup', value);
        this.$store.dispatch('applicant/actionSetRecognition', this.$route.params.id)
      },
      immediate: true
    }
  }
}
</script>

<style>
.border-bottom {
  margin-bottom: 2rem
}
.accordion-content{
  padding-bottom: 2rem;
}
.record-created {
  font-weight: 600;
  font-size: 12px;
  margin-left: 1rem;
}
.ql-editor{
  background: #ffffff;
}
.ql-editor h4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
</style>
